// extracted by mini-css-extract-plugin
export default {"headAd":"index_headAd_1Fl2T","logo":"index_logo_stswG","slide":"index_slide_6E4j6"};